module.exports = __webpack_public_path__ + "static/BasisGrotesquePro-Light-5b8cd51b927cb7b4ae1f2a4666d72bb8.woff";